import { SET_NOTIFICATIONS,CONNECT, DISCONNECT } from "../types/notificationsTypes";

const initialState = {
  all: [],
};

const notificationsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_NOTIFICATIONS:
      return { ...state, all: action.payload };
    case CONNECT:
      return {...state,isConnected: true};
    case DISCONNECT:
      return {...state,isConnected: false};
    default:
      return state;
  }
};

export default notificationsReducer;
